import { Link } from 'react-router-dom';
import { visibleNav } from '@/app/layouts/admin/nav';
import { useIsManager } from '@/access/usePerm';
import { useMe } from '@/auth/useMe';
import { useModules } from '@/access/useModule';

/**
 * קיצורי הניהול בתוך אפליקציית העובד. מנהל מדווח מהטלפון כמו כל עובד,
 * ולכן הבית שלו הוא אותו מסך, רק עם האזור הזה בנוסף. הניהול המלא
 * נמצא בקונסולה בדסקטופ.
 *
 * הרשימה נגזרת מאותו ניווט של הקונסולה, כדי שלא יהיו שתי רשימות
 * שמתפצלות עם הזמן.
 */
export function ManagerShortcuts() {
  const isManager = useIsManager();
  const { me } = useMe();
  const modules = useModules();

  if (!isManager) return null;

  const items = visibleNav(me?.permissions, modules)
    .flatMap((group) => group.items)
    .filter((item) => item.to !== '/admin');

  if (items.length === 0) return null;

  return (
    <section className="grid gap-2">
      <div className="flex items-end justify-between gap-2">
        <h2 className="m-0 font-display text-display-m font-semibold">ניהול</h2>
        <Link to="/admin" className="text-body-sm text-muted">
          לכל אזור הניהול
        </Link>
      </div>

      <ul className="grid list-none grid-cols-2 gap-2 p-0 sm:grid-cols-3">
        {items.map(({ to, label, icon: Icon }) => (
          <li key={to}>
            <Link
              to={to}
              className="grid min-h-24 content-center justify-items-center gap-2 rounded-md border border-line bg-surface p-3 text-center text-body-sm text-ink no-underline"
            >
              <Icon size={24} strokeWidth={1.75} aria-hidden="true" className="text-olive" />
              {label}
            </Link>
          </li>
        ))}
      </ul>

      <p className="m-0 text-body-sm text-muted">
        ניהול מלא, כולל טבלאות ולוח הסידור השבועי, נוח יותר מהמחשב.
      </p>
    </section>
  );
}
